import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { VbBtnPrimaryDirective } from 'rev-shared/ui/buttons/VbBtnPrimary.Directive';

import { VbDropdownMenuComponent } from './VbDropdownMenu.Component';
import { VbDropdownDirective } from './VbDropdown.Directive';

const components = [
	VbDropdownMenuComponent,
	VbDropdownDirective
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		VbBtnPrimaryDirective
	]
})
export class VbDropdownMenuModule {}
